import { Link } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { usePageSeo } from "@/lib/seo";

export default function NotFound() {
  usePageSeo({
    title: "Page not found | Park Communications",
    description: "The page you were looking for could not be found. Return to Park Communications, a strategic communications agency and crisis PR firm.",
    noindex: true,
  });

  return (
    <main data-testid="notfound-page">
      <Header solid linkBase="/" />
      <section className="relative bg-navy text-ivory grain overflow-hidden min-h-screen flex items-center">
        <div className="relative mx-auto max-w-3xl px-6 py-32 text-center">
          <p className="overline text-gold mb-6">404</p>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.03]">
            This page can&apos;t be found.
          </h1>
          <p className="text-ivory/65 text-lg leading-relaxed mt-8 max-w-xl mx-auto">
            The link may be broken or the page may have moved. Let&apos;s get you back on track.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" data-testid="notfound-home" className="inline-flex items-center gap-3 bg-gold hover:bg-ivory text-navy px-8 py-4 overline transition-colors">
              Back to home
            </Link>
            <a href="/#contact" data-testid="notfound-contact" className="inline-flex items-center gap-3 border border-white/25 hover:border-gold text-ivory px-8 py-4 overline transition-colors">
              Contact us
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
